import React from "react";
import { CheckCircle2, TrendingUp, Users } from "lucide-react";
import { about, companyInfo } from "@/data/mock";

const AboutSection = () => {
  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-[#edf011]">
              <img
                src={encodeURI(about.image)}
                alt="Fasilitas Produksi"
                className="w-full h-[500px] object-cover"
              />
            </div>

            <div className="absolute -bottom-8 -right-8 bg-[#a00e21] p-6 rounded-2xl shadow-2xl border-4 border-[#edf011]">
              <div className="flex items-center space-x-3">
                <div className="w-14 h-14 bg-[#edf011] rounded-full flex items-center justify-center">
                  <CheckCircle2 className="text-[#a00e21]" size={28} />
                </div>
                <div>
                  <p className="text-xl font-black text-white">Resmi</p>
                  <p className="text-sm text-gray-100 font-semibold">
                    Halal & Aman
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-8">
            <div>
              <span className="text-[#a00e21] font-black text-sm uppercase tracking-wider">
                Tentang SHAKTI
              </span>
              <h2 className="text-4xl md:text-5xl font-black text-gray-900 mt-3 leading-tight">
                Mitra Usaha, bukan sekadar pemasok bumbu
              </h2>
            </div>

            <div className="text-lg text-gray-700 leading-relaxed space-y-4">
              <p>
                SHAKTI hadir sebagai mitra usaha, bukan sekadar pemasok bumbu.
                Kami mengembangkan produk dengan formulasi yang stabil dan
                terstandar agar pelaku usaha dapat memproduksi secara konsisten
                tanpa bergantung pada trial &amp; error yang berisiko terhadap
                margin.
              </p>
              <p>
                Dengan pendekatan yang fokus dan berkelanjutan, SHAKTI mendukung
                pelaku usaha dalam mengembangkan produk, menjaga kualitas, dan
                memperkuat daya saing di pasar.
              </p>
            </div>

            <div className="text-sm text-gray-700 font-semibold bg-gray-50 border border-gray-200 rounded-xl p-4">
              <div className="font-black text-[#a00e21] mb-1">
                Alamat Produksi / Kantor
              </div>
              <div>{companyInfo.address}</div>
            </div>

            {/* Key points (tetap ringkas) */}
            <div className="space-y-4 pt-2">
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-[#edf011] rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <CheckCircle2 className="text-[#a00e21]" size={20} />
                </div>
                <div>
                  <h3 className="font-black text-gray-900 mb-1">
                    Formulasi Stabil & Terstandar
                  </h3>
                  <p className="text-gray-600 text-sm">
                    Membantu produksi konsisten dan mengurangi risiko trial &amp; error.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-[#edf011] rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <TrendingUp className="text-[#a00e21]" size={20} />
                </div>
                <div>
                  <h3 className="font-black text-gray-900 mb-1">
                    Mendukung Efisiensi Biaya
                  </h3>
                  <p className="text-gray-600 text-sm">
                    Fokus pada konsistensi rasa dan margin usaha yang terjaga.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-[#edf011] rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                  <Users className="text-[#a00e21]" size={20} />
                </div>
                <div>
                  <h3 className="font-black text-gray-900 mb-1">
                    Fokus B2B / Mitra Usaha
                  </h3>
                  <p className="text-gray-600 text-sm">
                    Cocok untuk UMKM, supplier, industri kecil–menengah, dan distributor.
                  </p>
                </div>
              </div>
            </div>

            {/* Optional: kalau stats masih mau dipakai */}
            {!!about?.stats?.length && (
              <div className="grid grid-cols-3 gap-6 pt-2">
                {about.stats.map((stat, i) => (
                  <div
                    key={i}
                    className="text-center p-4 rounded-xl border-2 border-[#a00e21]/20 hover:shadow-lg hover:border-[#a00e21] transition-all duration-300"
                  >
                    <p className="text-xl md:text-2xl font-black text-[#a00e21] mb-1">
                      {stat.number}
                    </p>
                    <p className="text-sm text-gray-700 font-bold">{stat.label}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
